import styled from 'styled-components'
import { CommunicationMultiSelectStyles } from '~/pages/communication/libs/communicationMultiSelectStyles'
import { COLORS } from '~/shared/constants/uiConstants'

export const StudyGoalCommunicationStyles = {
  ...CommunicationMultiSelectStyles,

  OptionsGrid: styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: space-between;
    gap: 10px;
    height: 400px;
    margin: auto 0;
  `,

  OptionButton: styled.button<{ $isSelected: boolean }>`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 10px;
    background: ${({ $isSelected }) => ($isSelected ? '#096ef9' : '#d5e6ff')};
    border: none;
    border-radius: 74px;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    touch-action: manipulation;
    transition: background 0.15s;

    &:active {
      background: ${({ $isSelected }) => ($isSelected ? '#096ef9' : '#d5e6ff')};
    }
  `,

  OptionLabel: styled.span<{ $isSelected: boolean }>`
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    color: ${({ $isSelected }) => ($isSelected ? COLORS.WHITE : COLORS.BLACK)};
  `,
}
